/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type ContractKind = typeof ContractKind[keyof typeof ContractKind];


export const ContractKind = {
  nda: 'nda',
  investor: 'investor',
  standard: 'standard',
} as const;
